/* global google, GMaps, MarkerClusterer */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import qs from 'qs';
import * as constants from '../util/constants';
import helpers from '../util/helpers';
import HotelsSkeleton from '../components/HotelsSkeleton/HotelsSkeleton';

const MapSkeleton = () => {
  return (
    <div className="map-wrapper skeleton-shine" />
  );
};

class AppGlobalHostEventSearch extends Component {
  constructor(props) {
    super(props);

    // Initial state
    this.initialState = {
      viewType: 'list',
      loading: true,
      results: [],
      resultLocations: [],
      heading: '',
      subHeading: '',
      loadMoreLoading: false,
      loadedAll: false,
    };

    // Assign first state
    this.state = Object.assign({}, this.initialState);

    this.location = helpers.docCookies.getItem(constants.COOKIE_KEY_VENUES_SEARCH_LOCATION);
    this.occasion = helpers.docCookies.getItem(constants.COOKIE_KEY_VENUES_SEARCH_OCCASION);
    this.guests = helpers.docCookies.getItem(constants.COOKIE_KEY_VENUES_SEARCH_GUESTS);

    // Bind "this"
    this.loadSearchResults = this.loadSearchResults.bind(this);
    this.loadMoreSearchResults = this.loadMoreSearchResults.bind(this);
    this.loadMap = this.loadMap.bind(this);

    // Cancel token source
    this.source = axios.CancelToken.source();
  }

  loadSearchResults() {
    // Stop loading old results
    if (this.state.loading) {
      this.source.cancel('Cancelled retrieving data');
      this.source = axios.CancelToken.source(); // Generate new source token
    }

    // Reset state
    this.setState({
      loading: true,
      results: [],
      resultLocations: [],
      heading: '',
      subHeading: '',
      loadMoreLoading: false,
      loadedAll: false,
    });

    // Params
    const data = {
      'action': constants.ACTION_GET_GLOBAL_VENUES,
      'location': this.location,
      'occasion': this.occasion,
      'guests': this.guests,
      'offset': 0,
    };

    // Send request
    axios.post(window.Rydges['ajaxUrl'], qs.stringify(data), {
      cancelToken: this.source.token,
    }).then((axiosResponse) => {
      if (200 === axiosResponse.status) {
        const response = axiosResponse.data;

        if (response.success) {
          const hotelsCount = response.data['hotels_count'];
          const venuesCount = response.data['venues_count'];
          const hotelVenues = [...response.data['venues']];
          const hotelLocations = [...response.data['hotel_locations']];

          if (0 === venuesCount) {
            this.setState({
              loading: false,
              heading: 'Oops',
              subHeading: 'No venues found',
              loadMoreLoading: false,
              loadedAll: true,
            });
          } else {
            this.setState({
              loading: false,
              results: hotelVenues,
              resultLocations: hotelLocations,
              heading: `${venuesCount}` + (1 === venuesCount ? ' Venue' : ' Venues'),
              subHeading: '',
              loadMoreLoading: false,
              loadedAll: hotelsCount == hotelVenues.length,
            });
          }
        } else {
          this.setState({
            heading: 'Oops',
            subHeading: 'Something went wrong.',
            loading: false,
            loadMoreLoading: false,
            loadedAll: true,
          });
        }
      }
    }).catch((error) => {
      console.log(error);
    });
  }

  loadMoreSearchResults(e) {
    e.preventDefault();

    const {
      results,
      loadedAll,
    } = this.state;

    if (!loadedAll) {
      this.setState({
        loading: false,
        loadMoreLoading: true,
      });

      // Params
      const data = {
        'action': constants.ACTION_GET_GLOBAL_VENUES,
        'location': this.location,
        'occasion': this.occasion,
        'guests': this.guests,
        'offset': results.length,
      };

      // Send request
      axios.post(window.Rydges['ajaxUrl'], qs.stringify(data), {
        cancelToken: this.source.token,
      }).then((axiosResponse) => {
        if (200 === axiosResponse.status) {
          const response = axiosResponse.data;

          if (response.success) {
            const hotelsCount = response.data['hotels_count'];
            const hotelVenues = [
              ...results,
              ...response.data['venues'],
            ];

            this.setState({
              loading: false,
              results: hotelVenues,
              loadMoreLoading: false,
              loadedAll: hotelsCount == hotelVenues.length,
            });
          } else {
            this.setState({
              heading: 'Oops',
              subHeading: 'Something went wrong.',
              loading: false,
              loadMoreLoading: false,
              loadedAll: true,
            });
          }
        }
      }).catch((error) => {
        console.log(error);
      });
    }
  }

  loadMap() {
    if ($('#hotels-map-wrapper').length) {
      const { resultLocations } = this.state;
      if (resultLocations.length > 0) {
        // Setup first item on map
        const map = new GMaps({
          div: '#hotels-map-wrapper',
          scrollwheel: false,
          center: new google.maps.LatLng(resultLocations[0]['location']['lat'], resultLocations[0]['location']['lng']),
          zoom: 15,
          markerClusterer: function(map) {
            return new MarkerClusterer(map, null, {
              styles: [
                {
                  textColor: 'white',
                  textSize: 20,
                  url: window.Rydges['assetsPath'] + 'images/map-markers/blank.svg',
                  height: 62,
                  width: 62,
                },
              ],
            });
          },
        });

        const mapMarkerInfoWindowTemplate = $('#hotels-map-marker-info-window').html();
        const bounds = [];

        for (let i = 0; i < resultLocations.length; i++) {
          if (Object.keys(resultLocations[i]['location']).length > 0) {
            const title = resultLocations[i]['title'];
            const lat = resultLocations[i]['location']['lat'];
            const lng = resultLocations[i]['location']['lng'];
            const link = resultLocations[i]['link'];

            bounds.push(new google.maps.LatLng(lat, lng));

            map.addMarker({
              lat: lat,
              lng: lng,
              title: title,
              icon: {
                scaledSize: new google.maps.Size(44, 44),
                url: window.Rydges['assetsPath'] + 'images/map-markers/default.svg',
              },
              infoWindow: {
                content: helpers.transformMapMarkerInfoWindow({
                  title,
                  image: resultLocations[i]['image'],
                  address: resultLocations[i]['address'],
                  link,
                }, mapMarkerInfoWindowTemplate),
              },
            });
          }
        }

        if (resultLocations.length > 1) {
          map.fitLatLngBounds(bounds);
        }
      }
    }
  }

  componentDidMount() {
    // Load results on first page load
    this.loadSearchResults();

    // Reload results on input changes
    document.addEventListener(constants.EVENT_SUBMIT_CLICKED_SEARCH, () => {
      const location = helpers.docCookies.getItem(constants.COOKIE_KEY_VENUES_SEARCH_LOCATION);
      const occasion = helpers.docCookies.getItem(constants.COOKIE_KEY_VENUES_SEARCH_OCCASION);
      const guests = helpers.docCookies.getItem(constants.COOKIE_KEY_VENUES_SEARCH_GUESTS);

      if (this.location !== location || this.occasion !== occasion || this.guests !== guests) {
        this.location = location;
        this.occasion = occasion;
        this.guests = guests;
        this.loadSearchResults();
      }
    });

    $(document).on(constants.EVENT_VIEW_TYPE_CHANGED, (e, viewType) => {
      this.setState({viewType});
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.loading ||
      (prevState.loading && !this.state.loading)
    ) {
      const resultsCount = $('h2.results-count');
      if (resultsCount.length) {
        if (this.state.loading) {
          resultsCount.text('');
        } else {
          resultsCount.text(this.state.heading);
        }
      }
    }

    if (
      (prevState.loading && !this.state.loading && this.state.viewType === 'map') ||
      (prevState.loadMoreLoading && !this.state.loadMoreLoading && this.state.viewType === 'map') ||
      (!this.state.loading && prevState.viewType !== 'map' && this.state.viewType === 'map')
    ) {
      this.loadMap();
    }

    if (
      (prevState.loading && !this.state.loading) ||
      (prevState.loadMoreLoading) ||
      (!this.state.loading && prevState.viewType !== 'list' && this.state.viewType === 'list')
    ) {
      // Equal height for elements
      $(document).trigger(constants.EVENT_BALANCE_ELEMENTS);
    }
  }

  render() {
    const {
      viewType,
      loading,
      results,
      loadMoreLoading,
      loadedAll,
    } = this.state;

    return (
      <React.Fragment>
        {
          viewType === 'list' && (
            <React.Fragment>
              <div className="hotel-result-container">
                {
                  !loading && results.length > 0 && (
                    results.map((venue, i) => {
                      return (
                        <div className="hotel-network-wrapper mb-5" key={i}>
                          <div className="row mb-5 align-items-center">
                            <div className="col-md-8">
                              <h3>{venue['location']} ({venue['function_rooms'].length})</h3>
                            </div>
                            {
                              venue['venues_overview_url'].length > 0 && (
                                <div className="col-md-4 text-lg-right">
                                  <a href={venue['venues_overview_url']} className="btn btn-outline-red btn-thin text-uppercase">
                                    Explore All Venues
                                  </a>
                                </div>
                              )
                            }
                          </div>

                          <div className="hotel-wrapper mb-3">
                            {
                              venue['function_rooms'].map((room, j) => {
                                return (
                                  <div className="single-hotel d-block" key={j}>
                                    <div className="single-hotel-wrapper mb-3">
                                      {
                                        room['images'].length > 0 && (
                                          <div className="preview-images">
                                            <div className="slider">
                                              {room['images'].map((image, k) => {
                                                return (
                                                  <a href={room['url']} className="slide bg-center" key={k} style={{backgroundImage: `url(${image})`}} />
                                                );
                                              })}
                                            </div>

                                            <button type="button" data-role="none" className="prev" aria-label="Prev" tabIndex="0" role="button">
                                              <img className="img-fluid" src={window.Rydges['assetsPath'] + 'images/icons/left-chevron-circle.svg'} alt="Prev"/>
                                            </button>

                                            <button type="button" data-role="none" className="next" aria-label="Next" tabIndex="1" role="button">
                                              <img className="img-fluid" src={window.Rydges['assetsPath'] + 'images/icons/right-chevron-circle.svg'} alt="Next"/>
                                            </button>
                                          </div>
                                        )
                                      }
                                      <a href={room['url']} className="hotel-info balance-elements d-block d-flex flex-column align-items-start">
                                        <div className="hotel-info-details w-100 mb-4 d-lg-none">
                                          <div className="detail-item">
                                            <span className="icon"><img className="img-fluid" src={window.Rydges['assetsPath'] + 'images/icons/icon-chair.svg'} alt="chair"/></span>
                                            <span className="info">100</span>
                                          </div>
                                          <div className="detail-item">
                                          <span className="icon"><img className="img-fluid" src={window.Rydges['assetsPath'] + 'images/icons/icon-man.svg'} alt="man"/></span>
                                            <span className="info">300</span>
                                          </div>
                                        </div>
                                        <h3 className="hotel-info-name mb-2" dangerouslySetInnerHTML={{__html: room['name']}}/>
                                        {room['distance'].length > 0 && <div className="distance">{room['distance']}</div>}
                                        <div className="hotel-info-details d-flex mb-3">
                                          {
                                            room['area'].length > 0 && (
                                              <div className="detail-item">
                                                <span className="label">Area : </span>
                                                <span className="info">{room['area']}&nbsp;m<sup>2</sup></span>
                                              </div>
                                            )
                                          }
                                          {
                                            room['capacity'].length > 0 && (
                                              <div className="detail-item">
                                                <span className="label">Max Capacity : </span>
                                                <span className="info">{room['capacity']}</span>
                                              </div>
                                            )
                                          }
                                          {
                                            room['classroom_capacity'].length > 0 && (
                                              <div className="detail-item d-none d-lg-block">
                                                <span className="icon"><img className="img-fluid" src={window.Rydges['assetsPath'] + 'images/icons/icon-chair.svg'} alt="chair"/></span>
                                                <span className="info">{room['classroom_capacity']}</span>
                                              </div>
                                            )
                                          }
                                          {
                                            room['cocktail_capacity'].length > 0 && (
                                              <div className="detail-item d-none d-lg-block">
                                                <span className="icon"><img className="img-fluid" src={window.Rydges['assetsPath'] + 'images/icons/icon-man.svg'} alt="man"/></span>
                                                <span className="info">{room['cocktail_capacity']}</span>
                                              </div>
                                            )
                                          }
                                        </div>
                                        <div className="hotel-info-excerpt mb-5 mb-lg-0">
                                          <p dangerouslySetInnerHTML={{ __html: room['description'] }}></p>
                                        </div>
                                        {
                                          room['price'].length > 0 && (
                                            <div className="hotel-info-price mt-auto">
                                              {room['price']}
                                            </div>
                                          )
                                        }
                                      </a>
                                    </div>
                                  </div>
                                );
                              })
                            }
                          </div>
                        </div>
                      );
                    })
                  )
                }
                {
                  (loading || loadMoreLoading) && (
                    <HotelsSkeleton/>
                  )
                }
              </div>
              <div className="text-center">
                <button className="btn btn-outline-red btn-thin text-uppercase btn-load-more mt-3" disabled={loading || loadMoreLoading || loadedAll } onClick={this.loadMoreSearchResults}>
                  {!loadedAll ? 'Load More' : 'That\'s All'}
                </button>
              </div>
            </React.Fragment>
          )
        }
        {
          viewType === 'map' && (
            <React.Fragment>
              {
                !loading
                  ? (
                    <div id="hotels-map-wrapper" className="map-wrapper" />
                  ) : (
                    <MapSkeleton />
                  )
              }
            </React.Fragment>
          )
        }
      </React.Fragment>
    );
  }
}

export default {
  init() {
    // JavaScript to be fired on init
  },
  finalize() {
    // JavaScript to be fired on loaded

    // Results
    const resultsWrapper = $('#search-venues-results-wrapper');
    if (resultsWrapper.length) {
      setTimeout(function() {
        ReactDOM.render(<AppGlobalHostEventSearch/>, resultsWrapper[0]);
      }, 1000);
    }

    const searchEventsForm = $('.search-events');
    if (searchEventsForm.length) {
      const venueLocationsSearch = searchEventsForm.find('.where');
      const venueOccasionsSearch = searchEventsForm.find('.occasions-search');
      const venueLocation = helpers.getParameterByName('location');
      const venueOccasion = helpers.getParameterByName('occasion');
      const venueLocationCookie = helpers.docCookies.getItem(constants.COOKIE_KEY_VENUES_SEARCH_LOCATION);
      const venueOccasionCookie = helpers.docCookies.getItem(constants.COOKIE_KEY_VENUES_SEARCH_OCCASION);
      const params = helpers.getParameters();

      // Set url params to cookie
      if (venueLocation != null && venueLocation.length) {
        params['location'] = venueLocation;
        venueLocationsSearch.val(venueLocation);
        helpers.docCookies.setItem(venueLocationsSearch.data('cookie-location'), venueLocation, 1500, '/');
      }
      if (venueOccasion != null && venueOccasion.length) {
        params['occasion'] = venueOccasion;
        venueOccasionsSearch.val(venueOccasion);
        helpers.docCookies.setItem(venueOccasionsSearch.data('cookie-occasion'), venueOccasion, 1500, '/');
      }

      // Set cookie to url params
      if ((venueLocation == null && venueLocationCookie) || (venueOccasion == null && venueOccasionCookie)) {
        if (venueLocationsSearch.length && venueLocation == null && venueLocationCookie) {
          params['location'] = venueLocationCookie;
        }
        if (venueOccasionsSearch.length && venueOccasion == null && venueOccasionCookie) {
          params['occasion'] = venueOccasionCookie;
        }
      }

      // Push params to url
      helpers.pushStateHistory(!$.isEmptyObject(params) ? '?' + $.param(params) : '');

      const handleUrlParamsOnInput = function() {
        const params = helpers.getParameters();

        if (venueLocationsSearch.length && venueLocationsSearch.val() !== '') {
          params['location'] = venueLocationsSearch.val();
        } else {
          delete params['location'];
        }
        if (venueOccasionsSearch.length && venueOccasionsSearch.val() !== '') {
          params['occasion'] = venueOccasionsSearch.val();
        } else {
          delete params['occasion'];
        }

        helpers.pushStateHistory(!$.isEmptyObject(params) ? '?' + $.param(params) : '');
      };

      const submitButton = searchEventsForm.find('button[type="submit"]');

      searchEventsForm.find('.where, .occasion, .guest')
        .on('input', function() {
          const _this = $(this);

          if (_this.val().length === 0) {
            handleUrlParamsOnInput();

            submitButton.prop('disabled', false);
          } else {
            submitButton.prop('disabled', true);
          }
        })
        .on('input_changed.rsd-ac', function() {
          handleUrlParamsOnInput();

          submitButton.prop('disabled', false);
        });

      // Trigger search on submit button clicked
      let timeout;
      submitButton.on('click', function(e) {
        e.preventDefault();

        clearTimeout(timeout);

        timeout = setTimeout(function() {
          document.dispatchEvent(helpers.initNewEvent(constants.EVENT_SUBMIT_CLICKED_SEARCH));
        }, 1000);
      });
    }

    // View types
    const hotelViewTypes = $('#hotel-view-types');
    if (hotelViewTypes.length) {
      const viewTypeItem = hotelViewTypes.find('.view-type-item');

      viewTypeItem.on('click', function(e) {
        e.preventDefault();

        const _this = $(this);
        const view = _this.data('view');

        viewTypeItem.removeClass('active');
        _this.addClass('active');

        $(document).trigger(constants.EVENT_VIEW_TYPE_CHANGED, [view]);
      });
    }

    // Trigger slick on results loaded
    const loadVenueSlider = () => {
      const slider = $('.single-hotel-wrapper .slider');
      if (slider.length) {
        slider.each(function() {
          const _this = $(this);

          if (!_this.hasClass('slick-initialized')) {
            _this.slick({
              dots: false,
              arrows: true,
              infinite: true,
              speed: 300,
              slidesToShow: 1,
              mobileFirst: true,
              prevArrow: _this.closest('.preview-images').find('.prev'),
              nextArrow: _this.closest('.preview-images').find('.next'),
            });
          }
        });
      }
    };

    $(document).on(constants.EVENT_BALANCE_ELEMENTS, loadVenueSlider);
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateGlobalHostEventSearch.js